export enum Day {
  SUN = 1,
  MON = 2,
  TUE = 3,
  WED = 4,
  THU = 5,
  FRI = 6,
  SAT = 7,
}

const DayMap = new Map<Day, string>([
  [Day.SUN, "Sun"],
  [Day.MON, "Mon"],
  [Day.TUE, "Tue"],
  [Day.WED, "Wed"],
  [Day.THU, "Thu"],
  [Day.FRI, "Fri"],
  [Day.SAT, "Sat"],
])

export function getDayName(key: Day) {
  return DayMap.get(key) || ""
}

export const WeekDays: DayOfWeek[] = [
  { Id: Day.SUN, Name: getDayName(Day.SUN) },
  { Id: Day.MON, Name: getDayName(Day.MON) },
  { Id: Day.TUE, Name: getDayName(Day.TUE) },
  { Id: Day.WED, Name: getDayName(Day.WED) },
  { Id: Day.THU, Name: getDayName(Day.THU) },
  { Id: Day.FRI, Name: getDayName(Day.FRI) },
  { Id: Day.SAT, Name: getDayName(Day.SAT) }
]

export default interface DayOfWeek {
  Id: Day
  Name: string
}
